

export enum DataSourceLabelsType {
  Button = 'button',
  Text = 'text'
}
